// Helper function to parse and render text with underline tags
import React from 'react';

export const parseTextWithUnderline = (text: string | null): (string | JSX.Element)[] => {
  if (!text) return [''];
  const parts = text.split(/(<0>.*?<\/0>)/g);
  return parts.map((part, index) => {
    if (part.startsWith('<0>') && part.endsWith('</0>')) {
      const content = part.slice(3, -4); // Remove <0> and </0>
      return <u key={index}>{content}</u>;
    }
    return part;
  });
};
